import { logError } from '@ptek/client-logger';
/**
 * Manages event handling for widgets
 */
export class WidgetEventManager {
    constructor() {
        Object.defineProperty(this, "eventHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        // Initialize empty event handlers map
    }
    /**
     * Emits an event to all registered handlers
     * @param eventName The event to emit
     * @param data Data to pass to event handlers
     * @returns This instance for chaining
     */
    emit(eventName, data = {}) {
        const handlers = this.eventHandlers.get(eventName);
        if (handlers) {
            handlers.forEach((handler) => {
                try {
                    handler(data);
                }
                catch (error) {
                    logError('WidgetEventManager', `Error in event handler for "${eventName}":`, error);
                }
            });
        }
        return this;
    }
    /**
     * Registers an event handler
     * @param eventName The event to listen for
     * @param handler Function to call when event occurs
     * @returns This instance for chaining
     */
    on(eventName, handler) {
        if (!this.eventHandlers.has(eventName)) {
            this.eventHandlers.set(eventName, []);
        }
        const handlers = this.eventHandlers.get(eventName);
        if (handlers) {
            handlers.push(handler);
        }
        return this;
    }
    /**
     * Unregisters an event handler
     * @param eventName The event to stop listening for
     * @param handler The handler function to remove
     * @returns This instance for chaining
     */
    off(eventName, handler) {
        const handlers = this.eventHandlers.get(eventName);
        if (handlers) {
            const index = handlers.indexOf(handler);
            if (index !== -1) {
                handlers.splice(index, 1);
            }
        }
        return this;
    }
    /**
     * Registers a one-time event handler
     * @param eventName The event to listen for once
     * @param handler Function to call when event occurs
     * @returns This instance for chaining
     */
    once(eventName, handler) {
        const onceHandler = ((data) => {
            handler(data);
            this.off(eventName, onceHandler);
        });
        return this.on(eventName, onceHandler);
    }
    /**
     * Removes all handlers for a specific event
     * @param eventName The event to clear handlers for
     * @returns This instance for chaining
     */
    clearEvent(eventName) {
        this.eventHandlers.delete(eventName);
        return this;
    }
    /**
     * Removes all event handlers
     * @returns This instance for chaining
     */
    clearAllEvents() {
        this.eventHandlers.clear();
        return this;
    }
}
//# sourceMappingURL=WidgetEventManager.js.map